module.exports = __webpack_public_path__ + "static/media/Up.d0dbbce0.svg";